import { render, staticRenderFns } from "./CardProcedure.vue?vue&type=template&id=e89b0dca&"
import script from "./CardProcedure.vue?vue&type=script&lang=js&"
export * from "./CardProcedure.vue?vue&type=script&lang=js&"
import style0 from "./CardProcedure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports